<ng-template #tpl>
  <div class="sg-flex-column sg-gap-20 simple-model-editor-container">
    <div mat-dialog-title>
      <sub class="sg-color-disabled">{{ title }}</sub>
      <sg-text variant="sg-heading-large-bold">{{ subTitle }}</sg-text>
    </div>
    <ng-content></ng-content>
    <pbl-nform
      #d
      [model]="model"
      [formClass]="formClass"
      [disabledState]="disabledState"
      [filter]="filter"
      [filterMode]="filterMode"
      (valueChanges)="valueChanges.emit({ event: $event, dynForm: d })"
      (beforeRender)="beforeRender.emit({ event: $event, dynForm: (dynForm = d) })">
      <div *nFormOverride="'*'; let ctx" [class]="ctx.item?.name">
        <ng-container *ngTemplateOutlet="renderer; context: { $implicit: ctx, dynForm: d }"></ng-container>
      </div>
    </pbl-nform>
    <div class="sg-flex-auto sg-flex-row sg-justify-end sg-items-center simple-model-editor-buttons-container sg-full-width">
      <sg-button text="Cancel" variant="secondary" (onClick)="takeAction(false)"></sg-button>
      <sg-button
        class="sg-margin-left-16"
        [text]="actionButtonLabel"
        variant="primary"
        [disabled]="canCommit ? !canCommit(d) : isFormInvalid"
        (onClick)="takeAction(true)"></sg-button>
    </div>
  </div>
</ng-template>
<ng-template #renderer let-ctx let-dynForm="dynForm">
  <material-form-control-renderer
    [nFormCmp]="dynForm"
    [nForm]="ctx.nForm"
    [fArray]="ctx.fArray"
    [fControl]="ctx.fControl"
    [fGroup]="ctx.fGroup"
    [item]="ctx.item"></material-form-control-renderer>
  @if (getErrors && getErrors(ctx); as errors) {
    <mat-icon class="sg-color-error" style="margin-left: 16px" [matTooltip]="errors">error_outline</mat-icon>
  }
</ng-template>
